import { indexes, pixToMm, referenceWidth, refRowHeight, refPadding } from '../../services/helpers/print/constants';
import { PageSizes } from '../../services/helpers/print';
import { PageOrientation } from '../../services/helpers/print/PageOrientation';
import { PageFormat } from '../../services/helpers/print/PageFormat';
import { PrintOptions } from '../../services/helpers/print/PrintOptions';
import { PageProperties } from './PageProperties';
import { HeaderStyle } from '../../models/enum';

const printMargins = 5 * pixToMm;//mm
const refColCount = 12;
const refColWidth = (referenceWidth - refPadding) / refColCount; //px

export function getPageProperties(printOptions: PrintOptions, headerStyle: HeaderStyle = HeaderStyle.Default): PageProperties {
    const pageSize = Object.assign({}, PageSizes[indexes[printOptions.format]]);

    const { orientation, format } = printOptions;
    if (orientation === PageOrientation.Landscape) {
        const h = pageSize.height;
        pageSize.height = pageSize.width;
        pageSize.width = h;
    }
    pageSize.width *= pixToMm;
    pageSize.height *= pixToMm;
    pageSize.width -= (2 * printMargins);
    pageSize.height -= 2 * printMargins;

    const colCount = orientation === PageOrientation.Portrait
        && format === PageFormat.A4
        ? 6
        : refColCount;

    const ratio = pageSize.width / (refColWidth * colCount + refPadding);// I did the maths, that's how you get it correct
    const colWidth = refColWidth * ratio;
    const rowHeight = refRowHeight * ratio;
    pageSize.width -= ratio * refPadding;
    if (headerStyle !== HeaderStyle.None) {
        const headerHeight = headerStyle === HeaderStyle.Compact
            ? 57*ratio // 57px would be the equivalent height of the compact header without scaling
            : 168*ratio; // 168px would be the equivalent height of the normal header without scaling
        pageSize.height -= headerHeight;
    }
    return {
        width: pageSize.width,
        height: pageSize.height,
        colWidth,
        rowHeight,
        orientation,
        format,
        ratio,
        nColumns: colCount
    };
}